// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__2hBBR","footer":"ChangeClinic_footer__1fM_v"};